import React from 'react';
import ReactDOM from 'react-dom/client';
import { restoreNativeSession, diag } from './nativeSession';

window.addEventListener('unhandledrejection', (e) => { const r = e.reason || {}; diag('rej ' + (r.code || r.message || r)); });

const root = ReactDOM.createRoot(document.getElementById('root'));

// Restore the saved login (native app only) BEFORE Firebase initialises, then load the app.
restoreNativeSession().finally(() => {
  import('./App').then(({ default: App }) => {
    root.render(<React.StrictMode><App /></React.StrictMode>);
  });
});
